import { render } from "./SongModal.vue?vue&type=template&id=751471f2"
import script from "./SongModal.vue?vue&type=script&lang=js"
export * from "./SongModal.vue?vue&type=script&lang=js"

import "./SongModal.vue?vue&type=style&index=0&id=751471f2&lang=css"
script.render = render

export default script